import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const ADDED_BUTTON_CLASS = 'coProto-addedButton';

const AddedButtonLabel = () => (
  <>
    <FontAwesomeIcon icon={faCheck} /> Added
    <span className='coProto-addedButton__more'> · Continue</span>
  </>
);

export default AddedButtonLabel;
